var _rect, _path, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 14,
    height: 12,
    rx: 1,
    transform: "rotate(-180 15 15)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99456 13C7.34846 13 6.80036 12.8948 6.35027 12.6845C5.90744 12.4742 5.5735 12.2113 5.34846 11.8958C5.13067 11.5728 5.01452 11.2423 5 10.9042C5 10.8366 5.02178 10.7803 5.06534 10.7352C5.10889 10.6901 5.16334 10.6676 5.22868 10.6676H6.23049C6.3902 10.6676 6.49909 10.7427 6.55717 10.893C6.71688 11.4263 7.19601 11.693 7.99456 11.693C8.43739 11.693 8.78221 11.5878 9.02904 11.3775C9.28312 11.1671 9.41016 10.8667 9.41016 10.4761C9.41016 10.0854 9.29401 9.80376 9.06171 9.63099C8.83666 9.4507 8.50272 9.36056 8.05989 9.36056H6.93829C6.8657 9.36056 6.80399 9.33427 6.75318 9.28169C6.70236 9.22911 6.67695 9.16526 6.67695 9.09014V8.60563C6.67695 8.46291 6.72414 8.35023 6.81851 8.26761L8.75681 6.30704H5.65336C5.5735 6.30704 5.50817 6.28075 5.45735 6.22817C5.40653 6.17559 5.38113 6.11174 5.38113 6.03662V5.28169C5.38113 5.19906 5.40653 5.13146 5.45735 5.07887C5.50817 5.02629 5.5735 5 5.65336 5H10.3358C10.4156 5 10.4809 5.02629 10.5318 5.07887C10.5826 5.13146 10.608 5.19906 10.608 5.28169V5.96901C10.608 6.09671 10.5608 6.20188 10.4664 6.28451L8.59347 8.27887L8.72414 8.29014C9.42105 8.35024 9.97278 8.56808 10.3793 8.94366C10.7931 9.31925 11 9.85634 11 10.5549C11 11.0507 10.8693 11.4826 10.608 11.8507C10.3539 12.2188 9.99819 12.5042 9.54084 12.707C9.09074 12.9023 8.57532 13 7.99456 13Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 2.75,
    width: 14.5,
    height: 12.5,
    rx: 2.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 5 0)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 13 0)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive3);
export default __webpack_public_path__ + "static/media/archive-3.da127698084322b3992863f7c38a701b.svg";
export { ForwardRef as ReactComponent };